export default __webpack_public_path__ + "static/media/forest_birds.514d18f0.png";